import { Action } from 'helpers/action-helpers';

export const GET_CONNECTION_STATUS = 'GetConnectionStatusAction';
export const SET_CONNECTION_STATUS = 'SetConnectionStatusAction';
export const SET_CONNECTION_STATUS_RUNNING = 'SetConnectionStatusRunningAction';
export const GET_OFFLINE_MODE_SIMULATION = 'GetOfflineModeSimulationAction';
export const SET_OFFLINE_MODE_SIMULATION = 'SetOfflineModeSimulationAction';

export class GetConnectionStatusAction extends Action {
  constructor() { 
    super(GET_CONNECTION_STATUS);
  }
}

export class SetConnectionStatusAction extends Action {
  constructor(public isConnected: boolean) { 
    super(SET_CONNECTION_STATUS);
  }
}

export class GetOfflineModeSimulationAction extends Action {
  constructor() { 
    super(GET_OFFLINE_MODE_SIMULATION);
  }
}

export class SetOfflineModeSimulationAction extends Action {
  constructor(public shouldSimulate: boolean) { 
    super(SET_OFFLINE_MODE_SIMULATION);
  }
}


// WEBPACK FOOTER //
// ./src/components/connection-status/actions.ts